import { render } from "./SliderListPage.vue?vue&type=template&id=4d97a4c5"
import script from "./SliderListPage.vue?vue&type=script&lang=js"
export * from "./SliderListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__